"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenTab = exports.Badge = exports.Bar = exports.TabsItem = exports.TabsHeader = exports.TabsHead = exports.TabsWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styled__TabsWrapper",
  componentId: "sc-1onnd1i-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: block;\n    user-select: none;\n    width: 100%;\n"])));

exports.TabsWrapper = TabsWrapper;

var TabsHead = _styledComponents["default"].div.withConfig({
  displayName: "styled__TabsHead",
  componentId: "sc-1onnd1i-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n    border-bottom: 1px solid ", ";\n    position: relative;\n"])), _constants.COLORS.grey);

exports.TabsHead = TabsHead;

var TabsHeader = _styledComponents["default"].div.withConfig({
  displayName: "styled__TabsHeader",
  componentId: "sc-1onnd1i-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-wrap: nowrap;\n    width: 100%;\n    justify-content: ", ";\n"])), function (props) {
  return props.justify ? 'space-between' : 'flex-start';
});

exports.TabsHeader = TabsHeader;

var TabsItem = _styledComponents["default"].div.withConfig({
  displayName: "styled__TabsItem",
  componentId: "sc-1onnd1i-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: block;\n    padding: 15px 0;\n    white-space: nowrap;\n    cursor: pointer;\n    position: relative;\n    /* font-weight: ", "; */\n    ", "\n    &:not(:last-child) {\n        margin-right: 30px;\n    }\n    &:hover {\n        color: ", ";\n    }\n"])), function (props) {
  return props.active ? '600' : '300';
}, function (props) {
  return props.active ? _constants.FONTS.Medium : _constants.FONTS.Regular16;
}, function (props) {
  return props.active ? '#000' : props.accentColor || _constants.COLORS.red;
});

exports.TabsItem = TabsItem;

var Bar = _styledComponents["default"].div.withConfig({
  displayName: "styled__Bar",
  componentId: "sc-1onnd1i-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    height: 2px;\n    background-color: ", ";\n    transition: width 0.4s ease-in-out, left 0.4s ease-in-out;    \n"])), function (props) {
  return props.accentColor || _constants.COLORS.red;
});

exports.Bar = Bar;

var Badge = _styledComponents["default"].span.withConfig({
  displayName: "styled__Badge",
  componentId: "sc-1onnd1i-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    position: absolute;\n    background: ", ";\n    border-radius: 10px;\n    ", ";\n    height: 20px;\n    padding: 0 6px;\n    color: white;\n    right: -20px;\n    top: 3px;\n    text-align: center;\n"])), _constants.COLORS.lightGreen, _constants.FONTS.XS);

exports.Badge = Badge;

var HiddenTab = _styledComponents["default"].div.withConfig({
  displayName: "styled__HiddenTab",
  componentId: "sc-1onnd1i-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    border: 0;\n    padding: 0;\n    opacity: 0;\n    white-space: nowrap;\n    clip-path: inset(100%);\n    clip: rect(0 0 0 0);\n    overflow: hidden;\n"])));

exports.HiddenTab = HiddenTab;